import { IonApp, IonContent } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

/* Components */
import Authentication from './components/globals/Authentication';
import AppUrlListener from './components/globals/AppUrlListener';
import Header from './components/globals/Header';
import Footer from './components/globals/Footer';
import SideBar from './components/sidebar/SideBar';

/* State */
import { AppContextProvider } from './state/AppContextProvider';

/* Services */

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* TailwindCSS */
import './theme/tailwind.css';

/* FondAwesome */
import './theme/font-awesome/all.css';

/* Theme variables */
import './theme/variables.css';

import './theme/globalstyles.css';
import Lang from './services/Lang';
import { AppContent } from './AppContent';
import { LoggingStorage } from './components/debug/LoggingStorage';
import { PushNotification } from './components/globals/PushNotification';
import { FetchChecklist } from './components/checklist/FetchChecklist';
import { LottieSplash } from './components/splash/LottieSplash';
import { IdentificationModal } from './components/identification/IdentificationModal';
import { ParentTagsLoader } from './components/tag/ParentTagsLoader';
import { EmergencyContacts } from './components/profile/EmergencyContacts';
import { WhenUserLoaded } from './components/globals/WhenUserLoaded';
import AxiosInterceptors from './components/globals/AxiosInterceptors';
import LoadDataOnce from './components/globals/LoadDataOnce';

const App: React.FC = () => (
  <AppContextProvider>
    <LottieSplash />
    <LoggingStorage>
      <Authentication>
        <AxiosInterceptors>
          <LoadDataOnce />
          <ParentTagsLoader />
          <Lang>
            <IonApp>
              <IonReactRouter>
                <IdentificationModal />
                <EmergencyContacts />
                <Header />
                <Footer />
                <IonContent>
                  <WhenUserLoaded>
                    <PushNotification />
                    <FetchChecklist />
                  </WhenUserLoaded>
                  <AppUrlListener></AppUrlListener>
                  <AppContent />
                </IonContent>
                <SideBar />
              </IonReactRouter>
            </IonApp>
          </Lang>
        </AxiosInterceptors>
      </Authentication>
    </LoggingStorage>
  </AppContextProvider>
);

export default App;
